module.exports = __webpack_public_path__ + "static/media/drop6.1fbd40a5.jpg";